export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Recover.vue?vue&type=style&index=0&id=9888159a&prod&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/login/Recover.vue?vue&type=style&index=0&id=9888159a&prod&lang=css&
// module id = 949
// module chunks = 0